import { Flex } from "@chakra-ui/react";


import PropTypes from "prop-types";
import React from "react";
import { SidebarResponsive } from "./../Sidebar/SidebarResponsive";



function HeaderLinks({ routes, onLinkClick, activePath }) {

  return (
    <Flex>
      {/* Icon Menu */}
      <SidebarResponsive
        routes={routes}
        onLinkClick={onLinkClick}
        activePath={activePath}
      />


    </Flex>
  );
}

export default HeaderLinks;
HeaderLinks.propTypes = {
  variant: PropTypes.string,
  onOpen: PropTypes.func,
};




